// The column keys shared by the table, saved views and Export. A key is
// either an entry detail —
//   _id     Entry ID        _date   Submitted
//   _by     Submitted by    _email  Email (the submitter's account email)
// — or a field id from the list's `columns`. The export file itself is
// built by the worker (pitpay-go) from the same keys.

export const META_LABELS = {
  _id: 'Entry ID',
  _date: 'Submitted',
  _by: 'Submitted by',
  _email: 'Email',
};

export const META_KEYS = Object.keys(META_LABELS);

export const isMetaKey = (key) =>
  Object.prototype.hasOwnProperty.call(META_LABELS, key);

// A field only older versions have keeps its label, marked "(removed)".
export const columnHeader = (column) =>
  column.removed ? `${column.label} (removed)` : column.label;

const byPosition = (a, b) => a.position - b.position;

export const orderedColumns = (columns) =>
  [...(columns || [])].sort(byPosition);

export const columnsById = (columns) =>
  (columns || []).reduce((acc, c) => {
    acc[c.field_id] = c;
    return acc;
  }, {});
